import { useRecoilState } from 'recoil';
import { UserAgentState } from 'src/recoil/common';

export const useUserAgent = () => {
  const [isUserAgent, setUserAgent] = useRecoilState(UserAgentState);

  const handleUserAgent = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      setUserAgent('MOBILEWEB');
    } else {
      setUserAgent('PCWEB');
    }
  };

  return { isUserAgent, handleUserAgent };
};
